var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('div', {
    staticClass: "slot-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('machine ID', null) + ": " + _vm.machineID))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('model', null) + ": " + _vm.modelID))])]), _vm._v(" "), _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v("Logout")]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "top",
      "title": _vm.$Jed.firstUpperTranslate('are you sure?', null),
      "content": _vm.$Jed.firstUpperTranslate('you are being redirected to the %1$s menu', null, {
        key: 'product identify'
      }),
      "ok": _vm.backward,
      "popoverStyle": {
        right: '10px',
        'max-width': '200px',
        width: '100%',
        'font-size': 'small',
        height: 'max-content',
        bottom: '60px'
      },
      "arrowStyle": {
        left: '75%'
      },
      "textStyle": {
        color: '#222'
      },
      "classes": "autoleft autotop"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin": "0px 5px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default",
    on: {
      "click": _vm.detail
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('detail', null)))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": _vm.man
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('new maintenance', null)))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.load
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('load', null)))])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-889fed8a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/MenuProdotto.vue
// module id = 1488
// module chunks = 1